import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Cart, FailureLarge, SuccessLarge } from '@yme/assets/icons';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { CART_URL, CART_URL_PUBLISH } from '@yme/common/constants';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS } from '@yme/modals/constants';
import { getLanguageRootPath, getExternalCartEnabled, getIsInAuthor } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { onOpenWindow } from '@yme/utils/common';
import { SELF } from '@yme/utils/constants';
import { PRODUCT_NAME_SEPARATOR } from './constants';
import { getErrorMessage } from './helpers';
import { IconWrapper } from './styled';
export function CartModalWindow({ productName = '', isRightToLeft, labels: { goToCartLabel, continueShoppingLabel, successTitleLabel, successMessageLabel, errorTitleLabel, confirmButtonLabel, outOfStockErrorMessageLabel, cartGroupErrorMessageLabel, cartUpdateErrorMessageLabel, }, cartErrorData, onHideModalCart, }) {
    const langRootPath = useSelector(getLanguageRootPath);
    const dispatch = useDispatch();
    const externalCartEnabled = useSelector(getExternalCartEnabled);
    const isInAuthor = useSelector(getIsInAuthor);
    let link;
    if (isInAuthor) {
        link = `${langRootPath}/${CART_URL}`;
    }
    else {
        link = `${langRootPath}/${CART_URL_PUBLISH}`;
    }
    const onSubmitHandler = useCallback(() => {
        if (cartErrorData) {
            onHideModalCart();
        }
        if (externalCartEnabled) {
            onHideModalCart();
            dispatch(setIsModalShowed({
                type: MODALS.REDIRECTION_EXTERNAL_CART_MODAL,
            }));
        }
        else {
            if (!cartErrorData) {
                onOpenWindow(link, SELF);
            }
        }
    }, [cartErrorData, dispatch, externalCartEnabled, link, onHideModalCart]);
    const modalFooter = (React.createElement(ModalWindowFooter, { isFooterColumn: true, isSubmitButton: true, isCancelButton: !cartErrorData, isCancelButtonFullWidth: !cartErrorData, isSubmitButtonFullWidth: !cartErrorData, onSubmit: onSubmitHandler, onHide: onHideModalCart, submitButtonLabel: cartErrorData ? confirmButtonLabel : goToCartLabel, cancelButtonLabel: continueShoppingLabel, isPreventedSubmit: false, submitButtonIcon: !cartErrorData ? Cart : undefined }));
    return (React.createElement(StaticModalWindow, { onHide: onHideModalCart, isRightToLeft: isRightToLeft, staticModalSize: MD_MODAL, minHeight: "initial", title: cartErrorData ? errorTitleLabel : successTitleLabel, footerComponent: modalFooter },
        React.createElement(FlexWrapper, { justifyContent: "center", isFullWidth: true, mb: INDENT.sm },
            React.createElement(IconWrapper, { hasError: Boolean(cartErrorData) },
                React.createElement(SVGIcon, { type: cartErrorData ? FailureLarge : SuccessLarge, size: ICON_SIZE.l }))),
        React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, !cartErrorData
            ? successMessageLabel.replace(PRODUCT_NAME_SEPARATOR, productName)
            : getErrorMessage(cartErrorData, productName, {
                outOfStockErrorMessageLabel,
                cartGroupErrorMessageLabel,
                cartUpdateErrorMessageLabel,
            }))));
}
